const Style = {
    history: 'flex flex-col text-sm',
    container: 'flex flex-col gap-1 pt-0.5',
    name: 'text-sm font-medium text-text-primary',
    date: 'mt-1 block text-xs text-text-muted',
    info: 'flex flex-wrap items-baseline gap-x-1 gap-y-0.5',
    divider: 'border-t my-1 border-border',
    event: 'text-sm leading-snug text-text-secondary',
};

export default Style;
